<template>
  <div class="auth-input-page">
    <label
      v-if="$store.state.app.onboarding.accountCategory !== 'listener'"
      class="auth-label-input"
    >
      Account type
    </label>
    <v-menu
      v-if="$store.state.app.onboarding.accountCategory !== 'listener'"
      bottom
      left
      offset-y
      :nudge-top="-5"
      :nudge-left="0"
      class="account-type-menu pb-1"
      content-class="account-menu__content"
    >
      <v-select
        :placeholder="accountType ? accountType.title : 'Select'"
        class="pa-0"
        :class="{ 'acc-selected _filled': accountType }"
        single-line
        hide-details
        slot="activator"
      ></v-select>

      <div
        v-for="(type, i) in accountTypes"
        :key="i"
        @click="selectedAccount(type)"
        class="account-info"
        :class="[`${type.id}-menu`]"
      >
        <div class="_title" style="font-size: 16px; font-weight: 600">
          {{ type.title }}
        </div>
        <div class="_tags">
          {{ type.tags }}
        </div>
      </div>
    </v-menu>
    <label class="auth-label-input">Username</label>
    <input
      v-model="username"
      type="text"
      placeholder="Type username"
      autocomplete="off"
      class="pb-2"
    />

    <div
      :class="{
        'display-flex align-center gap-8 justify-space-between':
          $vuetify.breakpoint.width <= 1280,
      }"
    >
      <v-btn
        v-if="$vuetify.breakpoint.width <= 1280"
        class="back-button"
        @click="$emit('actionPrevStage')"
      >
        Back
      </v-btn>
      <v-btn
        :class="{
          _disabled: !validated('skipToast'),
          'auth-bg-disabled': checkDataEmpty,
          'auth-bg-active': !checkDataEmpty,
        }"
        class="auth-button"
        @click="handleNextStage()"
      >
        Next
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import AuthService from "@/services/auth";

export default {
  data() {
    return {
      accountType: "",
      username: "",
    };
  },
  computed: {
    ...mapState({
      current: (state) => state.app.onboarding.current,
      getAccountType: (state) => state.app.onboarding.accountType,
      getUsername: (state) => state.app.onboarding.username,
    }),
    accountTypes() {
      let accountTypes = [];
      if (this.$store.state.app.onboarding.accountCategory === "creator") {
        accountTypes = [
          {
            id: "artist",
            title: "Artist",
            tags: "Bands, rappers, producers, podcasters + more",
          },
          {
            id: "brand",
            title: "Brand",
            tags: "Clothing, record labels, lifestyle + more",
          },
        ];
      } else {
        accountTypes = [
          {
            id: "listener",
            title: "Listener",
          },
        ];
      }

      return accountTypes;
    },
    checkDataEmpty() {
      return this.accountType == "" || this.username == "";
    },
  },
  methods: {
    ...mapActions({
      gotoNextStage: "app/nextOnboardingStage",
      gotoPrevStage: "app/prevOnboardingStage",
    }),
    ...mapMutations({
      updateOnboarding: "app/updateOnboarding",
    }),
    validated(toastStatus) {
      const skipToast = toastStatus === "skipToast";

      const { accountType, username } = this;
      const toValidate = [accountType, username];

      const errors = [
        "Please choose an account type",
        "Please enter a valid username",
      ];

      const isValid = toValidate.every((item, index) => {
        if (index == 1) {
          const regularExpression = /^[A-Za-z0-9_.]{3,20}$/;
          return regularExpression.test(item);
        }
        if (!skipToast && !item) {
          this.$store.dispatch("error/showErrorToast", [errors[index]]);
          return item;
        }
        return item;
      });

      return isValid;
    },
    selectedAccount(account) {
      this.accountType = account;
    },
    async handleNextStage() {
      let isUsernameAvailable = false;
      const regularExpression = /^[A-Za-z0-9_.]{3,20}$/;
      if (this.username == "" || !regularExpression.test(this.username)) {
        this.$store.dispatch("error/showErrorToast", [
          "Username must be between 3 to 20 characters without special characters in it",
        ]);
      } else {
        await AuthService.isUsernameAvailable({ username: this.username })
          .then((res) => {
            isUsernameAvailable = true;
          })
          .catch((e) => {
            this.$store.dispatch("error/showErrorToast", [
              "Username already exist",
            ]);
            isUsernameAvailable = false;
          });
      }

      if (this.validated() && isUsernameAvailable) {
        const data = {
          accountType: this.accountType,
          user_type: this.accountType.id,
          username: this.username,
        };
        this.updateOnboarding(data);

        this.gotoNextStage(this.current + 1);
      }
    },
    handlePrevStage() {
      if (this.current !== 1) {
        this.gotoPrevStage(this.current - 1);
      }
    },
  },
  created() {
    this.accountType = this.getAccountType;
    this.username = this.getUsername;
  },
  mounted() {
    if (this.$store.state.app.onboarding.accountCategory === "listener") {
      this.accountType = {
        id: "listener",
        title: "Listener",
      };
    }
  },
};
</script>

<style lang="scss" src="../../../../../static/styles/onboarding.scss"></style>

<style lang="scss" scoped>
.auth-button {
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

.back-button {
  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 18.68px;
  text-align: center;
  background: #0000000d;
  height: 50px;
  border-radius: 56px;
  margin: 30px 0 0 !important;
  box-shadow: none !important;
  width: 100%;
}

@media screen and (max-width: 1280px) {
  .auth-button {
    height: 50px !important;
    border-radius: 56px;
    font-size: 18px !important;
  }
}
</style>



// WEBPACK FOOTER //
// accountType.vue?4cdd72b7